import { ValidatorFn, AbstractControl, FormGroup } from '@angular/forms';
import { StringUtil } from '@univacity/shared/util';

export class CustomValidators {
  static validPassWord: ValidatorFn = (control: AbstractControl) => {
    const value = control.value;
    if (!value) return null;
    const re = StringUtil.passwordRex;
    if (re.test(value)) {
      return null;
    } else {
      const errors: string[] = [];
      if (!/[a-z].*/.test(value)) errors.push('1 Lowercase Character Required');
      if (!/[A-Z].*/.test(value)) errors.push('1 Uppercase Character Required');
      if (!/[0-9].*/.test(value)) errors.push('1 Number Required');
      if (!/[^\w\s].*/.test(value)) errors.push('1 Special Character Required');
      if (value.length < 8) errors.push('Minimum of 8 Characters');
      return { password: { errors } };
    }
  };

  static email: ValidatorFn = (control: AbstractControl) => {
    const value = control.value;
    if (!value) return null;
    const re = StringUtil.emailRex;
    if (re.test(value)) {
      return null;
    } else {
      return { email: $localize`Enter a valid email` };
    }
  };
  static validatePhone: ValidatorFn = (control: AbstractControl) => {
    const isOk = StringUtil.phoneRegx.test(control.value);
    return isOk ? null : { phone: { value: control.value } };
  };

  static fileRequired: ValidatorFn = (control: AbstractControl) => {
    const value = control.value;
    if (value?.src) {
      return null;
    } else {
      return { fileRequired: true };
    }
  };

  static mustMatch(
    controlName: string,
    matchingControlName: string
  ): ValidatorFn {
    return (formGroup: AbstractControl) => {
      if (!(formGroup instanceof FormGroup)) return null;
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (control.value !== matchingControl.value) {
        control.setErrors({ mustMatch: matchingControlName });
      } else {
        control.setErrors(null);
      }
      return null;
    };
  }
  static isBigger(
    controlName: string,
    matchingControlName: string
  ): ValidatorFn {
    return (formGroup: AbstractControl) => {
      if (!(formGroup instanceof FormGroup)) return null;
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.value > control.value) {
        control.setErrors({ isBigger: matchingControlName });
      } else {
        control.setErrors(null);
      }
      return null;
    };
  }
}
